import React, { useEffect, useMemo } from "react"

import { useFormContext } from "react-hook-form"

import { PolicyModalityCode } from "@common-shared/config/oneVerify/oneVerifyPolicies.config"

import { FRONT_VALIDATION_CONFIG } from "@front-shared/config/validation.config"
import { SelectElement } from "@front-shared/elements/select.element"
import type { ISelectRenderedOption } from "@front-shared/types/objects.types"

import { LookupHelper } from "../../../../helpers/lookup.helper"
import { useAppSelector } from "../../../../store/selectors/app.selector"
import { selectedPracticeRoleSelector } from "../../../../store/selectors/selectedPracticeRole.selector"
import type { IDynamicCheckerFormInputData } from "../../../../types/data.types"

export const ModalityCodeInput: React.FunctionComponent<
    IModalityCodeInputProps
> = props => {
    const {
        formState: { errors },
        register,
        setValue,
        watch,
    } = useFormContext<IDynamicCheckerFormInputData>()

    const dataWatcher = watch()
    const selectedPracticeRole = useAppSelector(selectedPracticeRoleSelector)

    const availableModalityCodes = useMemo<ISelectRenderedOption[]>(() => {
        return LookupHelper.getRenderedModalityCodes(
            selectedPracticeRole?.availableModalityCodes,
        )
    }, [selectedPracticeRole?.availableModalityCodes])

    const defaultModalityCode = useMemo<string | undefined>(() => {
        const formSetValue = props.defaultValue
            ? availableModalityCodes.find(
                  item => item.value === props.defaultValue,
              )?.displayValue
            : undefined

        return formSetValue || availableModalityCodes[0]?.displayValue
    }, [availableModalityCodes, props.defaultValue])

    useEffect(() => {
        props.onChange?.(dataWatcher.modalityCode)
    }, [dataWatcher.modalityCode])

    return (
        <div
            data-produktly="checker-select-service"
            className={`
                relative
                ${props.className}
            `}
        >
            <SelectElement
                label="Select Service"
                name="modalityCode"
                disabled={props.disabled}
                reactHookFormRegister={register as any}
                reactHookFormSet={setValue as any}
                reactHookFormErrors={errors}
                validations={{
                    required: FRONT_VALIDATION_CONFIG.required,
                }}
                renderedOptions={availableModalityCodes}
                defaultValue={defaultModalityCode}
            />
        </div>
    )
}

interface IModalityCodeInputProps {
    className?: string
    onChange?: (modalityCode?: PolicyModalityCode) => void
    defaultValue?: PolicyModalityCode
    disabled?: boolean
}
